var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$store.state.usuario.usuario == null)?_c('Header'):_vm._e(),(this.$store.state.usuario.usuario != null)?_c('HeaderLogged',{key:_vm.$route.fullPath}):_vm._e(),_c('v-main',{staticClass:"center"},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1),(this.$store.state.usuario.usuario == null)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }